import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';

/**
 * NF525 software identification popup (audit finding AUD-I-05317).
 *
 * All identification data — including the software version — comes from
 * point-of-sale's `FranceCertificateController`, so nothing needs passing in
 * from the Connect shell.
 */
let openInstance: Initializer | null = null;

const createNf525CertificateModal = (): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const instance: Initializer = {
    destroy: () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
      // Only clear the shared reference if it still points at this instance,
      // so a late teardown cannot orphan a newer modal.
      if (openInstance === instance) {
        openInstance = null;
      }
    },
    render: () => {
      ReactDOM.render(
        <Reconnect name="Nf525CertificateModal" props={{ onClose: instance.destroy }} />,
        container,
      );
    },
  };

  return instance;
};

/**
 * Opens the popup, replacing any previous instance so repeat clicks cannot
 * stack containers and duplicate federation fetches.
 *
 * Deliberately tears down and re-creates rather than no-oping when an instance
 * already exists: `Reconnect` swallows remote-load failures and never calls
 * `onClose`, so guarding on existence alone would leave the entry inert until
 * a full page reload.
 */
export const openNf525CertificateModal = (): void => {
  openInstance?.destroy();
  openInstance = createNf525CertificateModal();
  openInstance.render();
};
